import { ReactNode } from "react";
import { BoxProps, Grid } from "shared/components/Spor";
// This will only expand/collapse the children, thus it doesnt include a trigger

export const DropsExpandableContent = ({
  collapsed,
  children,
  ...rest
}: {
  collapsed: boolean;
  children: ReactNode;
} & BoxProps) => (
  <Grid
    gridTemplateRows={collapsed ? "0fr" : "1fr"}
    transition="all 0.3s ease"
    {...rest}
  >
    <div style={{ overflow: "hidden" }}>{children}</div>
  </Grid>
);
